import { useState, FC } from 'react';
import { Checkbox, IconButton, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import { useTranslation } from 'mir-utils/i18n';

type Props = {
  titles: Record<string, string>;
  selectedColumns: Record<string, boolean>;
  setSelectedColumns: (
    value:
      | Record<string, boolean>
      | ((storedValue: Record<string, boolean>) => Record<string, boolean>)
  ) => void;
};

/**
 * @summary Список, в котором можно указать, какие колонки отображать, а
 * какие нет.
 *
 * @param titles - Key - columnName и value - headtitle.
 * @param selectedColumns - Key - столбцы, value - отображается ли столбец.
 * @param setSelectedColumns - Сохранение в localStorage.
 */
export const MenuSelect: FC<Props> = ({ titles, selectedColumns, setSelectedColumns }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const { t } = useTranslation();

  return (
    <div>
      <Tooltip title={t('View Columns')}>
        <IconButton onClick={(event) => setAnchorEl(event.currentTarget)} size="large">
          <ViewWeekIcon />
        </IconButton>
      </Tooltip>
      <Menu
        id="enabled-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {Object.keys(titles).map((key) => (
          <MenuItem
            onClick={() => setSelectedColumns((store) => ({ ...store, [key]: !store[key] }))}
            key={titles[key]}
          >
            <Checkbox checked={selectedColumns[key]} />
            <ListItemText primary={titles[key]} />
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
